import { render, staticRenderFns } from "./ZenMahjongConfig.vue?vue&type=template&id=465f1db4"
import script from "./ZenMahjongConfig.vue?vue&type=script&lang=js"
export * from "./ZenMahjongConfig.vue?vue&type=script&lang=js"
import style0 from "./ZenMahjongConfig.vue?vue&type=style&index=0&id=465f1db4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports